import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var En = function En(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.2h15.865v9.6H0V3.2z",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "EN_svg__a",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 16,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3.2h15.865v9.6H0V3.2z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#EN_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.6 4.274V3.2H.53l7.401 3.727L5.801 8-1.6 4.274zm9.532 4.8L.532 12.8H-1.6v-1.073L5.8 8l2.131 1.073zm0 0L10.064 8l7.401 3.727V12.8h-2.131L7.932 9.073zM10.064 8L7.932 6.927 15.334 3.2h2.131v1.073L10.064 8z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.344 6.4V3.2H9.52v3.2h7.944v3.2H9.521v3.2H6.344V9.6H-1.6V6.4h7.944z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98 7.04V3.2h1.906v3.84h8.58v1.92h-8.58v3.84H6.979V8.96H-1.6V7.04h8.58zM-1.6 12.8l6.355-3.2h1.421l-6.355 3.2H-1.6zm6.355-6.4L-1.6 3.2v.716L3.334 6.4h1.421zm4.934 0l6.355-3.2h1.421L11.11 6.4H9.689zm1.421 3.2l6.355 3.2v-.715L12.531 9.6H11.11z",
    fill: "#C00"
  })));
};
export default En;